export default __webpack_public_path__ + "static/wood-icon-658d0d57017b875cd2b38f6999f52425.svg";